/**
 * Panoya kopyalama.
 *
 * Pano API'si yalnızca güvenli bağlamda (HTTPS veya localhost) çalışır ve
 * odak kaybı ya da izin reddi durumunda da hata atar. Depo içi kurulumda düz
 * HTTP kullanılabildiği için eski `execCommand` yöntemine düşülür —
 * kopyalama sessizce başarısız olmasın.
 */
export async function panoyaKopyala(deger: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(deger);
      return true;
    } catch {
      // Aşağıdaki yönteme düşülür.
    }
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = deger;
    // Görünmez ama seçilebilir olmalı; `display:none` olsaydı seçim çalışmazdı.
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}
